<template>
	<v-row align="center" justify="center">
		<v-col>
			<user-reset-password-form></user-reset-password-form>
			<br />
			<p align="center" class="white--text">
				Have an account?
				<router-link to="/" class="white--text">Sign In</router-link>
			</p>
		</v-col>
	</v-row>
</template>

<script>
import UserResetPasswordForm from '@/components/user/UserResetPasswordForm.vue';

export default {
	name: 'ResetPassword',
	components: {
		UserResetPasswordForm,
	},
};
</script>
